import { pluginConfig } from '../config.esm.js';

class S3Client {
  discoveryApi;
  identityApi;
  constructor({
    discoveryApi,
    identityApi
  }) {
    this.discoveryApi = discoveryApi;
    this.identityApi = identityApi;
  }
  async callApi(path, query, options) {
    const apiUrl = await this.discoveryApi.getBaseUrl(
      `${pluginConfig.pluginId}-backend`
    );
    const { token } = await this.identityApi.getCredentials();
    const response = await fetch(
      `${apiUrl}/${path}?${new URLSearchParams(query).toString()}`,
      {
        method: options?.method ?? "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!response.ok) {
      throw new Error(
        `Request failed for ${path}, ${response.status} ${response.statusText}`
      );
    }
    return await response.json();
  }
  async listBucketKeys(bucket, continuationToken, pageSize, page, folder, prefix) {
    const result = await this.callApi(
      `bucket/${encodeURIComponent(bucket)}/keys`,
      {
        continuationToken,
        pageSize,
        page,
        folder,
        prefix
      }
    );
    return result;
  }
  async getAllBuckets(accountId, bucketName) {
    const result = await this.callApi("buckets", {
      accountId,
      bucket: bucketName
    });
    return result;
  }
  async getObjectMetadata(bucket, key) {
    const result = await this.callApi(
      `bucket/${encodeURIComponent(bucket)}/${encodeURIComponent(key)}`,
      {}
    );
    return result;
  }
}

export { S3Client };
//# sourceMappingURL=AwsS3ApiClient.esm.js.map
